/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState, useRef} from 'react'
import ApexCharts, {ApexOptions} from 'apexcharts'
import {getCSS, getCSSVariableValue} from '../../../../assets/ts/_utils'
import {useThemeMode} from '../../../layout/theme-mode/ThemeModeProvider'
import {useIntl} from "react-intl";
import {useAuth} from '../../../../../app/modules/auth'
import {getGuidanceIndividualDistributionChart} from '../../../../../app/modules/guidance/guidances-list/core/_requests'
import {ChartModel, initialChartModel} from '../../../../../_metronic/partials/widgets/charts/_models'
import {useYear, useYearName} from '../../../../../_metronic/partials/layout/header-menus/YearsManager'
import {RoleModel} from '../../../../../app/modules/auth/core/_models'
import { useTerm, useTermName } from '../../../layout/header-menus/TermsManager';

type Props = {
  className: string
}

const GuidanceIndividualDistributionChart: React.FC<Props> = ({className}) => {
  const [guidanceIndividualDistributionChart, setGuidanceIndividualDistributionChart] = useState<ChartModel | undefined>(initialChartModel)
  const chartRef = useRef<HTMLDivElement | null>(null)
  const {mode} = useThemeMode()
  const intl = useIntl();
  const {currentUser, auth} = useAuth()
  const currentYearId = useYear()
  const currentTermId = useTerm()
  const currentYearName = useYearName()
  const currentTermName = useTermName()
  
  useEffect(() => {
    let query = ''
    if(auth?.currentRole===RoleModel.Admin)
      query = "&academicYearId=" + currentYearId
    else if(auth?.currentRole === RoleModel.InstitutionManager)
      query = "&institutionId=" + currentUser?.institutionId + "&academicYearId=" + currentYearId + "&termId=" + currentTermId
    else if(auth?.currentRole === RoleModel.Customer || auth?.currentRole === RoleModel.Person)
      query = "&customerId=" + currentUser?.customerId + "&academicYearId=" + currentYearId + "&termId=" + currentTermId
    else 
      query = "&institutionId=" + currentUser?.institutionId + "&subinstitutionId=" + currentUser?.subinstitutionId + "&academicYearId=" + currentYearId + "&termId=" + currentTermId+ "&employeeId=" + currentUser!.employeeId

      getGuidanceIndividualDistributionChart(query).then((value) => { 
      setGuidanceIndividualDistributionChart(value); 
    })
  }, [])

  

  

  const refreshMode = () => {
    if (!chartRef.current) {
      return
    }
    const height = parseInt(getCSS(chartRef.current, 'height'))
    const chart = new ApexCharts(chartRef.current, getChartOptions(height, guidanceIndividualDistributionChart))
      
    if (chart) {
      chart.render()
    }

    return chart      
  }

  useEffect(() => {
      const chart = refreshMode()
    
      return () => {
        if (chart) {
          chart.destroy()
        }
      }

  }, [chartRef, mode, guidanceIndividualDistributionChart])

  function getChartOptions(height: number, guidanceIndividualDistributionChart: ChartModel | undefined): ApexOptions {
    const labelColor = getCSSVariableValue('--kt-gray-500')
    const borderColor = getCSSVariableValue('--kt-gray-200')
    
    const colors = ['#ffc702', '#723aea', '#0d849b'];


    return {
      series:  guidanceIndividualDistributionChart?.series1 as Array<number>,
      labels: [intl.formatMessage({id: 'vxt'}), intl.formatMessage({id: 'pb0'}), intl.formatMessage({id: '4ny'})],
      chart: {toolbar: {
        show: true // menü gösterimi
      },
        width: 340,
        height:380,
        type: 'donut',
      },
      dataLabels: {
         enabled: true,
         formatter: function (val, opt) {
          const yuvarlanmisDeger = Number(String(val).split('.')[0]);
          return `${yuvarlanmisDeger}%`;
        },
      },
      colors:colors,
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
          },
          legend: {
            show: false
          }
        }
      }],
    legend: {
        show: true,
         position: 'bottom',
        offsetY: 0,
       formatter: function(seriesName:string,opts:any){
        const value =opts.w.globals.series[opts.seriesIndex] as  number;
        const total = (opts.w.globals.series as number[]).reduce((acc:number, value:number)=>acc+value,0);
        const percentage =((value/total)*100).toFixed(0);
        return `${seriesName}:${value}(${percentage}%)`; //Burası ilgili grafikte sayıları açıkca belirtmeye yarıyor
        
       }
      },
      
      stroke: {
        show: true,
        width: 2,
        colors: [borderColor],
      },
      
    }
  }

  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>{intl.formatMessage({id: '6fb'})}</span>
          <span className='text-muted fw-semibold fs-7'>{currentYearName} {currentTermName} {intl.formatMessage({id: '6fc'})}</span>
        </h3>
      </div>
      {/* end::Header */}

      {/* begin::Body */}
      <div className='card-body'>
        {/* begin::Chart */}
        <div ref={chartRef} id='kt_charts_widget_3_chart ' ></div>
        {/* end::Chart */}
      </div>
      {/* end::Body */}
    </div>
  )
}

export {GuidanceIndividualDistributionChart}
